module.exports = __webpack_public_path__ + "static/media/slide1.ee31ce42.gif";